<div class="oauth-container">
  <div class="oauth-content">
    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
      <div class="spinner"></div>
      <h2>Connecting your Shopify store...</h2>
      <p>Please wait while we complete the setup.</p>
    </div>

    <!-- Success State -->
    <div *ngIf="success && !loading" class="success-state">
      <h2>Shopify store connected successfully!</h2>
      <p>You'll be redirected to your store page in a moment.</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
      <h2>Connection failed</h2>
      <p class="error-message">{{ error }}</p>
      <button class="retry-btn" (click)="goBackToStores()">
        Back to Stores
      </button>
    </div>
  </div>
</div> 